import { createContext } from 'react';
import { User, Session } from '@supabase/supabase-js';

export type UserRole = 'visiteur' | 'apprenant_particulier' | 'admin_entreprise' | 'formateur' | 'admin_nocodeo';

export interface UserProfile {
  first_name?: string;
  last_name?: string;
}

export interface AuthContextType {
  user: User | null;
  session: Session | null;
  userRole: UserRole | null;
  profile: UserProfile | null;
  loading: boolean;
  signUp: (email: string, password: string, role?: UserRole, metadata?: Record<string, any>) => Promise<{ 
    user: User | null; 
    session: Session | null; 
    emailConfirmationRequired: boolean; 
    error: any; 
  }>;
  signIn: (email: string, password: string) => Promise<{ error: any }>;
  signOut: () => Promise<void>;
  isAdmin: boolean;
  isLearner: boolean;
  isAdminNoCodeo: boolean;
  isAdminEntreprise: boolean;
  isFormateur: boolean;
  canAccessTraining: boolean;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
